<script setup lang="ts">
import { onMounted, onUpdated, ref, useSlots } from 'vue';

import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

const browserStore = useBrowserStore();

const slots = useSlots();
const hasFooter = ref(false);

function checkFooterSlot(): void {
  const footerSlot = slots.footer?.({});
  hasFooter.value = !!(footerSlot && footerSlot.length);
}

onMounted(checkFooterSlot);
onUpdated(checkFooterSlot);
</script>

<template>
  <div
    class="car-trip-page-layout"
    :class="{
      mobile: browserStore.isSmallerThan900px,
    }"
  >
    <div class="left-panel" :class="{ 'has-footer': hasFooter }">
      <slot name="leftPanel" />
    </div>
    <div class="right-panel" :class="{ 'has-footer': hasFooter }">
      <slot name="rightPanel" />
    </div>
    <div class="footer"><slot name="footer" /></div>
  </div>
</template>

<style scoped lang="scss">
.car-trip-page-layout {
  --panel-width: 500px;
  --footer-height: 89px;

  width: 100vw;
  height: 100vh;

  display: grid;
  grid-template-columns: var(--panel-width) 1fr;
  grid-template-rows: 1fr auto;
  overflow: hidden;
  @include for-less-or-equal-than-1200-px {
    grid-template-rows: calc(100vh - var(--footer-height)) var(--footer-height);
  }

  .right-panel {
    grid-row: 1/-1;
    grid-column: 2/3;
    @include for-less-or-equal-than-1200-px {
      grid-row: 1/2;
      &:not(.has-footer) {
        grid-row: 1/-1;
      }
    }
  }

  .left-panel {
    height: 100%;
    grid-row: 1/-1;
    grid-column: 1/2;
    @include for-less-or-equal-than-1200-px {
      grid-row: 1/2;
      &:not(.has-footer) {
        grid-row: 1/-1;
      }
    }
  }

  .footer {
    grid-row: 2/3;
    grid-column: 2/3;
    z-index: 1;
    @include for-less-or-equal-than-1200-px {
      grid-column: 1/3;
    }
  }

  &.mobile {
    height: 100vh;
    height: 100svh;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .left-panel {
      overflow-y: auto;
    }
    .right-panel {
      display: none;
    }
  }
}
</style>
